import { render } from "./MobileMenu.vue?vue&type=template&id=0fbf5d74"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"
script.render = render

export default script